module.exports = __webpack_public_path__ + "media/application/images/icons/confidence-level-5-aa130efe0d3af026d21efec41b13ba1f.svg";